<!-- eslint-disable vue/singleline-html-element-content-newline -->
<!-- 大屏-时间查询-选择组件 -->
<template>
  <div class="body">
    <!--时间类型-->
    <div class="flex">
      <div style="line-height: 32px; margin-right: 10px">时间</div>
      <el-radio-group
        v-model="formData.timeType"
        style="margin-right: 15px"
        @change="timeTypeChange"
      >
        <el-radio-button v-if="fifteenVisible" label="15分钟">
          15分钟
        </el-radio-button>
        <el-radio-button v-if="hourVisible" label="小时">小时</el-radio-button>
        <el-radio-button v-if="dayVisible" label="日">日</el-radio-button>
        <el-radio-button v-if="monthVisible" label="月">月</el-radio-button>
        <el-radio-button v-if="yearVisible" label="年">年</el-radio-button>
      </el-radio-group>
    </div>
    <!--时间选择区域-->
    <div>
      <el-date-picker
        v-if="formData.timeType === '15分钟'"
        v-model="minuteRange"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :teleported="false"
        class="st-input-width"
        :format="options.dateFormat.dateAndMinute"
        :value-format="options.dateFormat.dateAndTime"
        :time-picker-options="timePickerOptions"
        @change="minuteChange"
      />
      <el-date-picker
        v-else-if="formData.timeType === '小时'"
        v-model="hoursRange"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始小时"
        end-placeholder="结束小时"
        :teleported="false"
        class="st-input-width"
        :format="options.dateFormat.dateAndHours"
        :value-format="options.dateFormat.dateAndHours"
        @change="hourChange"
      />
      <el-date-picker
        v-else-if="formData.timeType === '日'"
        v-model="dayRange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :teleported="false"
        class="st-input-width"
        :format="options.dateFormat.date"
        :value-format="options.dateFormat.date"
        @change="dayChange"
      />
      <el-date-picker
        v-else-if="formData.timeType === '月'"
        v-model="monthRange"
        type="monthrange"
        class="st-input-width"
        range-separator="至"
        start-placeholder="开始月份"
        end-placeholder="结束月份"
        :teleported="false"
        :format="options.dateFormat.yearMonth"
        :value-format="options.dateFormat.yearMonth"
        @change="monthChange"
      />
      <el-date-picker
        v-else
        v-model="yearRange"
        type="yearrange"
        class="st-input-width"
        range-separator="至"
        start-placeholder="开始年份"
        end-placeholder="结束年份"
        :teleported="false"
        :format="options.dateFormat.year"
        :value-format="options.dateFormat.year"
        @change="yearChange"
      />
    </div>
    <!--其它时段-->
    <div v-if="otherVisible" class="flex">
      <el-checkbox v-model="checked" label="对比其他时间段" size="large" />
      <div v-if="checked" style="margin-left: 10px">
        <el-date-picker
          v-if="formData.timeType === '15分钟' && fifteenVisible"
          v-model="otherRange"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :teleported="false"
          class="st-input-width"
          :format="options.dateFormat.dateAndMinute"
          :value-format="options.dateFormat.dateAndTime"
          :time-picker-options="timePickerOptions"
          @change="otherChange"
        />
        <el-date-picker
          v-else-if="formData.timeType === '小时' && hourVisible"
          v-model="otherRange"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始小时"
          end-placeholder="结束小时"
          :teleported="false"
          class="st-input-width"
          :format="options.dateFormat.dateAndHours"
          :value-format="options.dateFormat.dateAndHours"
          @change="otherChange"
        />
        <el-date-picker
          v-else-if="formData.timeType === '日'"
          v-model="otherRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :teleported="false"
          class="st-input-width"
          :format="options.dateFormat.date"
          :value-format="options.dateFormat.date"
          @change="otherChange"
        />
        <el-date-picker
          v-else-if="formData.timeType === '月'"
          v-model="otherRange"
          type="monthrange"
          class="st-input-width"
          range-separator="至"
          start-placeholder="开始月份"
          end-placeholder="结束月份"
          :teleported="false"
          :format="options.dateFormat.yearMonth"
          :value-format="options.dateFormat.yearMonth"
          @change="otherChange"
        />
        <el-date-picker
          v-else-if="formData.timeType === '年'"
          v-model="otherRange"
          type="yearrange"
          class="st-input-width"
          range-separator="至"
          start-placeholder="开始年份"
          end-placeholder="结束年份"
          :teleported="false"
          :format="options.dateFormat.year"
          :value-format="options.dateFormat.year"
          @change="otherChange"
        />
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, watch, computed } from 'vue';
import options from '@/utils/options';

// eslint-disable-next-line newline-after-var
const emits = defineEmits(['update:modelValue', 'change']),
  props = defineProps({
    //时间类型： 15分钟、小时、日、月、年
    modelValue: {
      type: Object,
      default: () => {}
    },
    //15分钟 按钮是否显示
    fifteenVisible: {
      type: Boolean,
      default: true
    },
    //1小时 按钮是否显示
    hourVisible: {
      type: Boolean,
      default: true
    },
    //日 按钮是否显示
    dayVisible: {
      type: Boolean,
      default: true
    },
    //月 按钮是否显示
    monthVisible: {
      type: Boolean,
      default: true
    },
    //年 按钮是否显示
    yearVisible: {
      type: Boolean,
      default: true
    },
    //对比其它时间段 是否显示
    otherVisible: {
      type: Boolean,
      default: true
    }
  });

//最终结果集
let formData = ref({
    timeType: '15分钟', //时间类型： 15分钟、小时、日、月、年
    otherChecked: false, //是否选中对比其它时段数
    dateTimeRange: [String, String], //查询时间区间
    otherTimeRange: [String, String] //对比时段区间
  }),
  minuteRange = ref(), //选择的15分区间
  hoursRange = ref(), //选择的小时分区间
  dayRange = ref(), //选择日期区间
  monthRange = ref(), //选择月份区间
  yearRange = ref(), //选择年份区间
  checked = ref(false), //是否选中对比其它时段
  otherRange = ref(); //选择对比其它时段时间区间

//15分钟改变监听
// eslint-disable-next-line one-var
const minuteChange = (value) => {
    formData.value.dateTimeRange = value;
    emits('change');
  },
  //小时改变监听
  hourChange = (value) => {
    formData.value.dateTimeRange = value;
    emits('change');
  },
  // 日期改变监听
  dayChange = (value) => {
    formData.value.dateTimeRange = value;
    emits('change');
  },
  // 月份改变监听
  monthChange = (value) => {
    formData.value.dateTimeRange = value;
    emits('change');
  },
  //年份改变监听
  yearChange = (value) => {
    formData.value.dateTimeRange = value;
    emits('change');
  },
  //对比其它日期改变监听
  otherChange = (value) => {
    formData.value.otherTimeRange = value;
    emits('change');
  },
  //时间类型改变
  timeTypeChange = (value) => {
    formData.value.dateTimeRange = null;
    formData.value.otherTimeRange = null;
    minuteRange.value = null; //选择的15分区间
    hoursRange.value = null; //选择的小时分区间
    dayRange.value = null; //选择日期区间
    monthRange.value = null; //选择月份区间
    yearRange.value = null; //选择年份区间
    otherRange.value = null; //选择对比其它时段时间区间
    emits('change');
  },
  // 时间选择器选项(
  // eslint-disable-next-line no-undef
  timePickerOptions = computed(() => ({
    // 禁用所有秒选择
    disabledSeconds: () => {
      return Array.from({ length: 60 }, (_, i) => i);
    },
    // 只允许选择 00, 15, 30, 45 分钟
    disabledMinutes: () => {
      const allMinutes = Array.from({ length: 60 }, (_, i) => i),
        allowedMinutes = [0, 15, 30, 45];

      return allMinutes.filter((minute) => !allowedMinutes.includes(minute));
    }
  }));

//监听函数
watch(
  () => props.modelValue,
  (newValue) => {
    formData.value = newValue;
  },
  {
    immediate: false, //watch会在创建后立即执行一次
    deep: true //监听深度嵌套的对象属性
  }
);
//监听函数
watch(
  () => formData.value,
  (newValue) => {
    emits('update:modelValue', newValue);
  },
  {
    immediate: false, //watch会在创建后立即执行一次
    deep: true //监听深度嵌套的对象属性
  }
);
</script>
<style lang="scss" scoped>
.body {
  display: flex;
  align-items: center;
  gap: 5px;
}
</style>
